import React, { useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { MaterialPropType } from 'propTypes/common';
import VideoPlayer from 'components/VideoPlayer';
import Icon from 'components/Icon';

import { checkAndEvokeEmbedUrl } from 'utils/helpers/url';
import { getPreviewUrl } from 'utils/helpers/files';

import styles from './styles.module.scss';

const Video = ({
	material,
	url,
	responsive,
	autoPlay = false,
	isInteractive,
	className
}) => {
	const [showInteractiveVideo, setShowInteractiveVideo] = useState(false);
	const [autoPlayVideo, setAutoPlayVideo] = useState(autoPlay);

	const embedSrc = !_.isEmpty(material)
		? checkAndEvokeEmbedUrl(material, autoPlay)
		: url || null;

	const previewVideo =
		isInteractive && !!material && material.file?.previews?.length
			? getPreviewUrl(material.file.previews[0])
			: null;

	const stylesPreview =
		isInteractive && previewVideo
			? {
					backgroundColor: '#ece5d6',
					backgroundImage: `url("${previewVideo}")`
			  }
			: null;

	const onShowVideo = () => {
		setShowInteractiveVideo(true);
		setAutoPlayVideo(true);
	};

	return (
		<div
			className={cx(
				styles.Video,
				responsive && styles.Video_responsive,
				isInteractive && styles.Video_isInteractive,
				className
			)}
		>
			{isInteractive && !showInteractiveVideo && (
				<div className={styles.Video__Preview} style={stylesPreview}>
					<button
						type="button"
						className={styles.Video__Button}
						title="Воспроизвести видео"
						onClick={onShowVideo}
					>
						<Icon icon="audio-playIcon" className={styles.Video__ButtonIcon} />
					</button>
				</div>
			)}
			{(!isInteractive || (isInteractive && showInteractiveVideo)) && (
				<VideoPlayer
					_id={material?._id}
					title={material?.title}
					markupAttributes={{
						closeButton: { 'data-player': 'stop' }
					}}
					player={material?.player}
					autoPlay={autoPlayVideo}
					{...{ responsive, embedSrc }}
				/>
			)}
		</div>
	);
};
Video.propTypes = {
	url: PropTypes.string,
	material: MaterialPropType,
	responsive: PropTypes.bool,
	autoPlay: PropTypes.bool,
	isInteractive: PropTypes.bool,
	className: PropTypes.string
};

export default Video;
